import React, { useState } from 'react';
import { useAuth } from '../hooks/use-auth';
import { Button } from './ui/button';
import { AuthTokenModal } from './auth-token-modal';

export function TokenDebugButton() {
  const { isAuthenticated } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsModalOpen(true)}
        className="text-xs"
      >
        🔑 View Token
      </Button>
      <AuthTokenModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
